import { UserRound, Building, Code, LineChart } from 'lucide-react';
const Clients = () => {
  return <section id="clients" className="section bg-dark ">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-offWhite">
            Who I <span className="text-cyanPrimary">Work With</span>
          </h2>
          <p className="text-lg text-offWhite/80 leading-relaxed">
            I partner with mission-driven teams that need strategic product leadership to bring their vision to life.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
          <div className="bg-grayLight p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow border-l-4 border-cyan-400">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-grayMid rounded-full flex items-center justify-center mr-4">
                <UserRound className="text-offWhite" size={24} />
              </div>
              <h3 className="text-xl font-semibold text-offWhite text-left">Founders</h3>
            </div>
            <p className="text-offWhite/70 mb-4 text-left">
              Early-stage startup founders with strong missions but no in-house product leader. You have a vision but need help defining what to build and how to build it.
            </p>
            
          </div>
          
          <div className="bg-grayLight p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow border-l-4 border-cyan-400">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-grayMid rounded-full flex items-center justify-center mr-4">
                <Building className="text-offWhite" size={24} />
              </div>
              <h3 className="text-xl font-semibold text-offWhite text-left">VCs / PE Firms / Accelerators</h3>
            </div>
            <p className="text-offWhite/70 mb-4 text-left">
              Investors and accelerators looking for product support across their early-stage portfolio companies. You want to provide additional value to your portfolio.
            </p>
            
          </div>
          
          <div className="bg-grayLight p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow border-l-4 border-cyan-400">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-grayMid rounded-full flex items-center justify-center mr-4">
                <Code className="text-offWhite" size={24} />
              </div>
              <h3 className="text-xl font-semibold text-offWhite text-left">Engineering / Design Teams</h3>
            </div>
            <p className="text-offWhite/70 mb-4 text-left">
              Technical teams who need a product partner to define what to build and why. You have the skills to build but need direction on product strategy.
            </p>
            
          </div>
          
          <div className="bg-grayLight p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow border-l-4 border-cyan-400">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-grayMid rounded-full flex items-center justify-center mr-4">
                <LineChart className="text-offWhite" size={24} />
              </div>
              <h3 className="text-xl font-semibold text-offWhite">Growth-Stage Teams</h3>
            </div>
            <p className="text-offWhite/70 mb-4 text-left">
              Companies seeking to revisit or evolve their product strategy. You have an existing product but need help taking it to the next level.
            </p>
            
          </div>
        </div>
        
        {/* Scroll indicator to show there's more content below */}
        <div className="flex justify-center mt-16">
          <div className="animate-bounce flex flex-col items-center">
            <p className="text-xs text-offWhite/70 mb-2 tracking-wider">Scroll for testimonials and featured work</p>
            <div className="w-0.5 h-6 bg-offWhite/30 rounded"></div>
          </div>
        </div>
      </div>
    </section>;
};
export default Clients;